import { track } from '@mc/track-event'
import { CHECKOUT_BACK_NAV_TYPES, CheckoutEvents } from '../../lib/constants'

type CheckoutBackNavType =
  (typeof CHECKOUT_BACK_NAV_TYPES)[keyof typeof CHECKOUT_BACK_NAV_TYPES]

// Fires on /checkout when the user got there by pressing browser back out of
// /checkout/payment. Checkout runs on a single URL, so back exits the flow
// entirely instead of stepping back within it; this measures how often that
// happens and which step it happens from.
export const trackCheckoutBackExit = ({
  originStep,
  navType,
  isGift,
}: {
  originStep: string
  navType: CheckoutBackNavType
  isGift: boolean
}) => {
  track(CheckoutEvents.EVENTS.CHECKOUT_BACK_EXIT, {
    origin_step: originStep,
    nav_type: navType,
    is_gift: isGift,
    location: 'falcon_cart',
  })
}
